import { render, staticRenderFns } from "./ModalFinalisation.vue?vue&type=template&id=2a542dd1&"
import script from "./ModalFinalisation.vue?vue&type=script&lang=js&"
export * from "./ModalFinalisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports